import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { capitalize } from 'lodash-es';
import { AUTH_PROVIDERS } from 'site-modules/shared/components/profile/auth-providers';

export function SocialButton({ name, onSignIn, isSpinnerActive = false, className = null }) {
  return (
    <Button
      name={name}
      className={classnames('auth-submit-button text-white', `${name}-button`, className, {
        'spinner-active': isSpinnerActive,
      })}
      color=""
      disabled={isSpinnerActive}
      data-tracking-id="authenticate_social_start"
      data-tracking-value={AUTH_PROVIDERS[name].authAction}
      block
      data-no-refresh
      onClick={onSignIn}
    >
      <i className="spinner icon-spinner8 me-0_5" aria-hidden />
      <i className={classnames('icon pointer-event-none', `icon-${AUTH_PROVIDERS[name].iconName}`)} aria-hidden />
      <span className="ps-0_5 mb-0 pointer-event-none">Continue with {capitalize(name)}</span>
    </Button>
  );
}
SocialButton.propTypes = {
  name: PropTypes.string.isRequired,
  onSignIn: PropTypes.func.isRequired,
  isSpinnerActive: PropTypes.bool,
  className: PropTypes.string,
};
